export class Utils {
  public static BACKEND_BASE_URL =
    window.location.protocol +
    "//" +
    window.location.hostname +
    "/api/";
  public static LINE_DIAGRAM_COLOR = "hsl(193deg 95% 51%)";
}
